import React, { Component, createRef } from "react";
import {
    StyleSheet,
    View,
    Text,
    ScrollView,
    TouchableOpacity,
    Modal,
    Pressable,
    Platform,
} from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import {
    readMenuAnchorRectSync,
    computeDropdownMenuPlacement,
    getDropdownViewportHeightPx,
    rectsClose,
    subscribeDropdownAnchorGuards,
} from "../../utils/dropdownMenuAnchor";

export default class DropDownLocations extends Component {
    triggerRef = createRef();

    state = {
        isVisible: false,
        selected: null,
        menuRect: null,
    };
    componentDidMount() {
        const { openList, openDropDown } = this.props;
        if (openList) {
            this.setState({ isVisible: true }, () => this.measureAndOpen(openDropDown));
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.updated != this.props.updated || nextProps.reset != this.props.reset) {
            this.setState({ selected: nextProps.updated ? nextProps.updated : [] });
        }
        if (nextProps.openList != this.props.openList) {
            if (nextProps.openList) {
                this.setState({ isVisible: true }, () =>
                    this.measureAndOpen(nextProps.openDropDown)
                );
            } else {
                this.setState({ isVisible: false, menuRect: null });
            }
        }
        if(nextProps.isDropDownOpened != this.props.isDropDownOpened && !nextProps.isDropDownOpened){
            this.setState({ isVisible: false, menuRect: null });
          }
  
    }
    measureAndOpen = (openDropDown) => {
        const node = this.triggerRef.current;
        if (!node || typeof node.measureInWindow !== "function") {
            this.setState({ menuRect: { x: 0, y: 0, width: 200, height: 60 } });
            if (openDropDown) openDropDown();
            return;
        }
        requestAnimationFrame(() => {
            const syncRect = readMenuAnchorRectSync(node);
            if (syncRect) {
                this.setState({ menuRect: syncRect }, () => {
                    if (openDropDown) openDropDown();
                });
                return;
            }
            node.measureInWindow((x, y, width, height) => {
                this.setState(
                    { menuRect: { x, y, width: width || 200, height: height || 60 } },
                    () => { if (openDropDown) openDropDown(); }
                );
            });
        });
    };

    applyMenuAnchorIfOpen = () => {
        if (!this.state.isVisible || !this.state.menuRect) return;
        const node = this.triggerRef.current;
        const syncRect = readMenuAnchorRectSync(node);
        if (syncRect) {
            this.setState((prev) => {
                if (!prev.isVisible || !prev.menuRect) return null;
                const p = prev.menuRect;
                if (rectsClose(p, syncRect)) return null;
                return { menuRect: syncRect };
            });
            return;
        }
        if (!node || typeof node.measureInWindow !== "function") return;
        node.measureInWindow((x, y, width, height) => {
            const nextRect = { x, y, width: width || 200, height: height || 60 };
            this.setState((prev) => {
                if (!prev.isVisible || !prev.menuRect) return null;
                const p = prev.menuRect;
                if (rectsClose(p, nextRect)) return null;
                return { menuRect: nextRect };
            });
        });
    };
    closeMenu = (syncParent = true) => {
        this.stopMenuAnchorUpdates();
        const { resetDropDown, isDropDownOpened } = this.props;
        this.setState({ isVisible: false, menuRect: null }, () => {
            if (syncParent && isDropDownOpened && typeof resetDropDown === "function") {
                resetDropDown();
            }
        });
    };

    componentDidUpdate(prevProps, prevState) {
        const showingMenu = this.state.isVisible && !!this.state.menuRect;
        const wasShowingMenu = prevState.isVisible && !!prevState.menuRect;
        if (showingMenu && !wasShowingMenu) {
            this.startMenuAnchorUpdates();
        } else if (!showingMenu && wasShowingMenu) {
            this.stopMenuAnchorUpdates();
        }
    }

    componentWillUnmount() {
        this.stopMenuAnchorUpdates();
    }

    startMenuAnchorUpdates = () => {
        this.stopMenuAnchorUpdates();
        if (Platform.OS === "web" && typeof window !== "undefined" && typeof window.requestAnimationFrame === "function") {
            this._detachAnchorGuards = subscribeDropdownAnchorGuards(
                () => this.triggerRef.current,
                () => this.applyMenuAnchorIfOpen()
            );
            const loop = () => {
                if (!this.state.isVisible || !this.state.menuRect) {
                    this.stopMenuAnchorUpdates();
                    return;
                }
                this.applyMenuAnchorIfOpen();
                this._anchorRafId = window.requestAnimationFrame(loop);
            };
            this._anchorRafId = window.requestAnimationFrame(loop);
            return;
        }
        this._menuAnchorInterval = setInterval(() => {
            if (!this.state.isVisible || !this.state.menuRect) {
                this.stopMenuAnchorUpdates();
                return;
            }
            const node = this.triggerRef.current;
            if (!node || typeof node.measureInWindow !== "function") return;
            node.measureInWindow((x, y, width, height) => {
                const nextRect = { x, y, width: width || 200, height: height || 60 };
                this.setState((prev) => {
                    if (!prev.isVisible || !prev.menuRect) return null;
                    const p = prev.menuRect;
                    if (rectsClose(p, nextRect)) return null;
                    return { menuRect: nextRect };
                });
            });
        }, 50);
    };

    stopMenuAnchorUpdates = () => {
        if (typeof this._detachAnchorGuards === "function") {
            this._detachAnchorGuards();
            this._detachAnchorGuards = null;
        }
        if (this._anchorRafId != null && typeof window !== "undefined" && typeof window.cancelAnimationFrame === "function") {
            window.cancelAnimationFrame(this._anchorRafId);
            this._anchorRafId = null;
        }
        if (this._menuAnchorInterval != null) {
            clearInterval(this._menuAnchorInterval);
            this._menuAnchorInterval = null;
        }
    };

    renderOptionsList = (backgroundColor, options, allLabel, selectedOption) => {
        const { onSelect } = this.props;
        return (
            <ScrollView style={{...styles.options, backgroundColor: backgroundColor ? backgroundColor : '#ffff'}} keyboardShouldPersistTaps="handled">
                <TouchableOpacity
                    style={styles.item}
                    key={0}
                    onPress={() => {
                        var selected = ["all_location"];
                        onSelect(selected);
                        this.setState({ selected: selected, isVisible: false, menuRect: null }, () => {
                            const { resetDropDown, isDropDownOpened } = this.props;
                            if (isDropDownOpened && typeof resetDropDown === "function") {
                                resetDropDown();
                            }
                        });
                    }}
                >
                    <Text style={styles.label}>{allLabel}</Text>
                </TouchableOpacity>
                {options.map((option, idx) => (
                    <TouchableOpacity
                        style={styles.item}
                        key={idx}
                        onPress={() => {
                            var selected = [option];
                            onSelect(selected);
                            this.setState({ selected: selected, isVisible: false, menuRect: null }, () => {
                                const { resetDropDown, isDropDownOpened } = this.props;
                                if (isDropDownOpened && typeof resetDropDown === "function") {
                                    resetDropDown();
                                }
                            });
                        }}
                    >
                        <Text style={styles.label}>{this.renderDetailItem(option)}</Text>
                    </TouchableOpacity>
                ))}
            </ScrollView>
        );
    };
    renderDetailItem(item) {
        var completeLocation = "";
        if(item == "default_location"){
            completeLocation += "Default Location";
        }
        if(item == "all_location"){
            completeLocation += "All Locations";
        }
        if (item?.site?.locationName) {
            completeLocation += item.site.locationName;
        }
        if (item?.zone?.locationName) {
            completeLocation += "-" + item.zone.locationName;
        }
        if (item?.aisle?.locationName) {
            completeLocation += "-" + item.aisle.locationName;
        }
        if (item?.rackBay?.locationName) {
            completeLocation += "-" + item.rackBay.locationName;
        }
        if (item?.shelfLevel?.locationName) {
            completeLocation += "-" + item.shelfLevel.locationName;
        }
        if (item?.bin?.locationName) {
            completeLocation += "-" + item.bin.locationName;
        }
        // console.log(completeLocation);
        return completeLocation;
    }
    render() {
        const { isVisible, selected, menuRect } = this.state;
        const { options, initialOption, onSelect, defaultComponent, defaultLabel, allLabel, allValue, width, openDropDown, backgroundColor, isLast, resetDropDown } = this.props;
        const selectedOption = selected ? selected : initialOption;
        const viewportH = getDropdownViewportHeightPx();
        const { menuTop, menuMaxHeight } = computeDropdownMenuPlacement(menuRect, viewportH);
        return (
            <View style={styles.container} ref={this.triggerRef} collapsable={false}>
                <TouchableOpacity
                    style={styles.button}
                    disabled={!options || options?.length == 0}
                    onPress={() => {
                        if (!defaultComponent) {
                            if (!isVisible) {
                                this.setState({ isVisible: true }, () => this.measureAndOpen(openDropDown));
                            } else {
                                this.closeMenu(true);
                            }
                        }
                    }}
                >
                    <View style={{ width: width == 'mini' ? '80%' : '90%' }}>
                        {
                            (selectedOption && typeof selectedOption == "object") && selectedOption.map((selected, idx) => {
                                return <Text key={idx} style={{ ...styles.label, paddingLeft: 10, paddingVertical: 10 }}>{selected == "default_location" ? allLabel : this.renderDetailItem(selected)}</Text>
                            })
                        }
                    </View>
                    <MaterialCommunityIcons
                        name="chevron-down"
                        size={30}
                        color="#9B9B9B"
                        style={styles.icon}
                    />
                </TouchableOpacity>
                <Modal
                    visible={isVisible && !!menuRect}
                    transparent
                    //animationType="fade"
                    onRequestClose={() => this.closeMenu(true)}
                    statusBarTranslucent
                >
                    <Pressable style={styles.modalBackdrop} onPress={() => this.closeMenu(true)} />
                    {menuRect ? (
                        <View
                            style={[
                                styles.modalMenu,
                                {
                                    left: menuRect.x,
                                    top: menuTop,
                                    width: menuRect.width,
                                    maxHeight: menuMaxHeight,
                                },
                            ]}
                            pointerEvents="box-none"
                        >
                            {this.renderOptionsList(backgroundColor, options, allLabel, selectedOption)}
                        </View>
                    ) : null}
                </Modal>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        flexDirection: "column",
        alignSelf: "stretch",
        width: "100%",
        position: "relative",
        overflow: "hidden",
        zIndex: 1,
    },
    modalBackdrop: {
        ...StyleSheet.absoluteFillObject,
        backgroundColor: "rgba(0,0,0,0.01)",
    },
    modalMenu: {
        position: "absolute",
        zIndex: 10000,
        elevation: 24,
    },
    button: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        flex: 1,
        borderWidth: 1,
        borderColor: "#e7e7e7",
        borderRadius: 5,
        paddingLeft: 10,
        height: 60,
        backgroundColor: 'lightgray'
    },
    label: {
        fontSize: 16,
        color: "#333",
        fontWeight: "200",
        fontFamily: "Roboto",
        wordBreak: 'break-all',
        width: '100%'
    },
    icon: {
        width: 30,
        height: 30,
        marginRight: 5,
    },
    options: {
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#e7e7e7",
        borderRadius: 5,
        borderTopLeftRadius: 0,
        paddingBottom: 5,
        width: "100%",
        maxHeight: 200
    },
    item: {
        paddingLeft: 10,
        paddingVertical: 10,
    }
});
